import React from 'react';
import './Cart.css';

/**
 * 需求澄清與背景說明：
 * Cart.js 已經將 API response 統一轉換為如下格式：
 * {
 *   id,
 *   barcode, // 條碼
 *   product_name, // 品名
 *   remaining_stock, // 剩餘庫存
 *   visible_quantity, // 現貨系統可販售數
 *   system_price, // 現貨系統價格
 *   system_store, // 現貨系統活動
 *   producer, // 出品商
 *   series, // 系列
 *   product_type, // 類型
 *   role1, role2, others,
 *   imageUrl // 商品圖片網址
 *   qty // 數量
 * }
 * 
 * 主要挑戰：
 * - 需完全依賴上述欄位，不再使用舊格式（如 item['品名']、item['條碼'] 等）
 * - 若欄位不存在需有預設值
 * - 價格欄位以 system_price 為主
 * 
 * 追問：未來若 API 欄位再變動，是否希望集中在 Cart.js 處理 mapping？
 */

function MobileCartItem({ item, onQtyChange, onRemove }) {
  // 容錯處理，確保欄位存在
  const {
    imageUrl,
    product_name,
    barcode,
    system_price,
    qty = 1,
    system_store,
  } = item;

  // 價格處理
  const price = Number(system_price) || 0;
  const total = price * qty;

  return (
    <div className="cart-item mobile">
      <img
        className="cart-item-image"
        src={imageUrl}
        alt={product_name || '商品圖片'}
        onError={e => { e.target.onerror = null; e.target.src = '/404.jpg'; }}
      />
      <div className="cart-item-details">
        <div className="cart-item-name">{product_name || '未命名商品'}</div>
        <div className="cart-item-barcode">{barcode || '無條碼'}</div>
        {system_store && system_store.includes("活動") && (
          <div className="cart-item-activity">{item.system_store.split(".")[1]}</div>
        )}
        <div className="cart-item-qty">
          <button
            className="qty-btn"
            onClick={() => onQtyChange(item, -1)}
            disabled={qty <= 1}
          >−</button>
          <span className="qty-value">{qty}</span>
          <button
            className="qty-btn"
            onClick={() => onQtyChange(item, 1)}
            disabled={qty >= 99}
          >＋</button>
        </div>
        <div className="cart-item-price">參考金額：{price.toLocaleString()}</div>
        <div className="cart-item-total">小計：{total.toLocaleString()}</div>
        <button className="cart-item-remove" onClick={() => onRemove(item)}>移除</button>
      </div>
    </div>
  );
}

export default MobileCartItem;